import React from 'react';
import RESectionHeader from './RESectionHeader';

export default function REFinancialOverview() {
  return (
    <>
      <RESectionHeader title="Financial Overview" showHelp />
      <div className="mt-3 p-3">
        <h4>Financial Overview</h4>
        <p className="text-muted">Coming soon.</p>
      </div>
    </>
  );
}
